import axios from 'axios'

const state = {
  gameResult: [],
  resultLoaded: true,
  koQualifiers: [],
  qualifiersLoaded: true,
}

const getters = {
  gameResult: state => state.gameResult,
  resultLoaded: state => state.resultLoaded,
  koQualifiers: state => state.koQualifiers,
  qualifiersLoaded: state => state.qualifiersLoaded,
}

const actions = {
  getGameResult ({ commit }, tourId) {
    commit('RESULT_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/groupGameResult/' + tourId, { headers: header } )
    .then(response => {
      commit('GAMERESULT', response.data)
      commit('RESULT_LOADED', true)
    })
  },
  getKOQualifiers ({ commit }, tourId) {
    commit('QUALIFIERS_LOADED', false)
    const header = { 'x-auth': localStorage.getItem('authToken') }
    axios.get('/api/knockoutQualifier/' + tourId, { headers: header } )
    .then(response => {
      commit('KOQUALIFIERS', response.data)
      commit('QUALIFIERS_LOADED', true)
    })
  },
}

const mutations = {
  GAMERESULT(state, payload) {
    state.gameResult = payload
  },
  RESULT_LOADED(state, payload) {
    state.resultLoaded = payload
  },
  KOQUALIFIERS(state, payload) {
    state.koQualifiers = payload
  },
  QUALIFIERS_LOADED(state, payload) {
    state.qualifiersLoaded = payload
  }
}

export default {
  state, getters, actions, mutations
}
